import React, { useState } from 'react';
import { inject } from 'mobx-react';
import { Select } from 'core/form';
import LabelOptionRenderer from 'app/components/labels/LabelOptionRenderer';
import LabelValueTagRenderer from 'app/components/labels/LabelValueTagRenderer';

const categorizeOptions = (companyFullName, options, collapsedGroups) => {
  if (!options || !Array.isArray(options)) {
    return options;
  }

  const noneOption = options.find((option) => option.value === '-');
  const presets = [];
  const company = [];

  options.forEach((option) => {
    if (option.value === '-') {
      return;
    }

    if (option.isPreset) {
      presets.push(option);
    } else {
      company.push(option);
    }
  });

  const result = [];

  if (noneOption) {
    result.push(noneOption);
  }

  if (presets.length > 0 && company.length === 0) {
    result.push(...presets);
  } else if (company.length > 0 && presets.length === 0) {
    result.push(...company);
  } else {
    if (presets.length > 0) {
      const presetsGroupId = 'header-presets';
      result.push({
        label: 'KENTIK PRESETS',
        value: presetsGroupId,
        isGroupHeader: true,
        isCollapsed: collapsedGroups.includes(presetsGroupId)
      });

      if (!collapsedGroups.includes(presetsGroupId)) {
        result.push(
          ...presets.map((option) => ({
            ...option,
            groupId: presetsGroupId
          }))
        );
      }
    }

    if (company.length > 0) {
      const companyGroupId = 'header-company';
      result.push({
        label: companyFullName.toUpperCase(),
        value: companyGroupId,
        isGroupHeader: true,
        isCollapsed: collapsedGroups.includes(companyGroupId)
      });

      if (!collapsedGroups.includes(companyGroupId)) {
        result.push(
          ...company.map((option) => ({
            ...option,
            groupId: companyGroupId
          }))
        );
      }
    }
  }

  return result;
};

export const LabelMultiSelect = inject('$auth')(({
  $auth,
  field,
  fill,
  menuWidth,
  hideFilter = false,
  options,
  ...props
}) => {
  const [collapsedGroups, setCollapsedGroups] = useState([]);
  const rawOptions = field?.options || options || [];
  const categorizedOptions = categorizeOptions($auth.companyFullName || 'COMPANY', rawOptions, collapsedGroups);

  const handleToggleGroup = (groupId) => {
    setCollapsedGroups((prevCollapsed) =>
      prevCollapsed.includes(groupId) ? prevCollapsed.filter((id) => id !== groupId) : [...prevCollapsed, groupId]
    );
  };

  let modifiedField = field;
  if (field) {
    modifiedField = {
      ...field,
      options: categorizedOptions,
      getValue: field.getValue ? field.getValue.bind(field) : () => field.value
    };
  }
  return (
    <Select
      optionRenderer={(option) => LabelOptionRenderer({ ...option, onToggleGroup: handleToggleGroup })}
      valueTagRenderer={LabelValueTagRenderer}
      fill={!menuWidth || fill} // defaults to true but disabled if you provide menuWidth
      multi
      keepOpen
      toggle
      showClearButton
      showFilter={!hideFilter} // defaults to true
      showSelectAll
      menuWidth={menuWidth}
      field={modifiedField}
      {...props}
    />
  );
});
